/* Delegated hover/focus only. Reuses the real size links; no image, catalogue or cart requests. */
(function () {
  'use strict';
  if (window.__mipCardSizeFlyout) return;
  window.__mipCardSizeFlyout = true;
  var desktop = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  var active = null, openTimer = 0, closeTimer = 0, dismissed = null;
  function closest(node, selector) { return node && node.closest ? node.closest(selector) : null; }
  function inActive(node) { return !!(node && active && (active.card.contains(node) || active.panel.contains(node))); }
  function close(restoreFocus) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    var old = active; active = null;
    if (!old) return;
    if (restoreFocus && old.panel.contains(document.activeElement)) {
      var link = old.card.querySelector('.card-link, .pc-title a');
      if (link) link.focus({ preventScroll: true });
    }
    if (old.native) { try { old.panel.hidePopover(); } catch (ignore) {} }
    old.panel.removeAttribute('data-mip-size-open');
    old.panel.removeAttribute('data-mip-size-side');
    if (old.placeholder) {
      if (old.placeholder.isConnected) old.placeholder.replaceWith(old.panel);
      else old.panel.remove();
    }
    if (old.originalStyle === null) old.panel.removeAttribute('style');
    else old.panel.setAttribute('style', old.originalStyle);
  }
  function position() {
    if (!active) return;
    var panel = active.panel, box = active.anchor.getBoundingClientRect();
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var margin = 12, gap = 7, width = panel.getBoundingClientRect().width;
    var topEdge = margin;
    // A partially scrolled card must not place a top-layer list over the sticky header.
    document.querySelectorAll('.section-header-navigation, .mip-desktop-filterbar').forEach(function (header) {
      var r = header.getBoundingClientRect();
      if (r.height > 0 && r.top < vh * .35 && r.bottom > 0 && r.bottom < vh - 100) {
        topEdge = Math.max(topEdge, r.bottom + 6);
      }
    });
    var right = vw - margin - box.right - gap, left = box.left - margin - gap;
    var side = panel.dataset.pcPreferredSide === 'left' ? 'left' : 'right';
    if (side === 'right' && right < width && left >= width) side = 'left';
    else if (side === 'left' && left < width && right >= width) side = 'right';
    if (left < width && right < width) {
      if (Math.max(left, right) >= 125) {
        side = right >= left ? 'right' : 'left';
        width = Math.floor(Math.max(left, right)); panel.style.width = width + 'px';
      } else side = 'below';
    }
    panel.style.maxHeight = Math.min(352, vh - topEdge - margin) + 'px';
    var height = panel.getBoundingClientRect().height;
    var x = side === 'right' ? box.right + gap : side === 'left' ? box.left - width - gap : box.right - width;
    var y = side === 'below' ? box.bottom + gap : box.top;
    x = Math.max(margin, Math.min(x, vw - width - margin));
    y = Math.max(topEdge, Math.min(y, vh - height - margin));
    panel.style.left = Math.round(x) + 'px'; panel.style.top = Math.round(y) + 'px';
    panel.style.setProperty('--mip-size-arrow', Math.max(16, Math.min(box.top + 24 - y, height - 28)) + 'px');
    panel.dataset.mipSizeSide = side;
  }
  function open(card) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!desktop.matches || card === dismissed || !card.isConnected) return;
    if (active && active.card === card) return;
    var panel = card.querySelector('[data-pc-size-flyout]');
    var anchor = card.querySelector('.card-product__wrapper');
    if (!panel || !anchor || !panel.querySelector('a.pc-size-panel__item')) return;
    // Never allow a background card to open over a modal dialog.
    if (document.querySelector('dialog[open], [data-mip-filter-popover]:not([hidden]), [data-mip-region-open]')) return;
    close(false);
    active = { card: card, panel: panel, anchor: anchor, originalStyle: panel.getAttribute('style'), native: false, placeholder: null };
    panel.style.left = '-9999px'; panel.style.top = '0';
    panel.setAttribute('data-mip-size-open', '');
    if (typeof panel.showPopover === 'function') {
      try { panel.showPopover(); active.native = true; } catch (ignore) {}
    }
    if (!active.native) {
      var mark = document.createComment('size-flyout-home'); panel.before(mark);
      active.placeholder = mark; document.body.appendChild(panel);
    }
    position();
  }
  function requestOpen(card, keyboard) {
    clearTimeout(closeTimer); clearTimeout(openTimer);
    if (!card || card === dismissed) return;
    if (active && active.card === card) return;
    if (keyboard) open(card); else openTimer = setTimeout(function () { open(card); }, 80);
  }
  document.addEventListener('pointerover', function (event) {
    if (!desktop.matches || event.pointerType === 'touch') return;
    if (active && active.panel.contains(event.target)) { clearTimeout(closeTimer); clearTimeout(openTimer); return; }
    var card = closest(event.target, '.pc-premium');
    if (card && !card.contains(event.relatedTarget)) { dismissed = null; requestOpen(card, false); }
    else if (card && active && active.card === card) clearTimeout(closeTimer);
  });
  document.addEventListener('pointerout', function (event) {
    if (!desktop.matches || event.pointerType === 'touch') return;
    var card = closest(event.target, '.pc-premium');
    if (card && !card.contains(event.relatedTarget)) {
      clearTimeout(openTimer);
      if (dismissed === card) dismissed = null;
    }
    if (active && inActive(event.target) && !inActive(event.relatedTarget)) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        // Focused size links remain usable without depending on the mouse.
        if (active && !inActive(document.activeElement)) close(false);
      }, 150);
    }
  });
  document.addEventListener('focusin', function (event) {
    if (!desktop.matches) return;
    if (active && active.panel.contains(event.target)) { clearTimeout(closeTimer); return; }
    var card = closest(event.target, '.pc-premium');
    if (card && event.target.matches(':focus-visible')) requestOpen(card, true);
    else if (active && !inActive(event.target)) close(false);
  });
  document.addEventListener('focusout', function (event) {
    if (active && inActive(event.target) && !inActive(event.relatedTarget)) close(false);
    if (dismissed && dismissed.contains(event.target) && !dismissed.contains(event.relatedTarget)) dismissed = null;
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && active) {
      dismissed = active.card; close(true); event.preventDefault();
    }
  });
  document.addEventListener('pointerdown', function (event) { if (active && !inActive(event.target)) close(false); });
  // Ignore the list's own scroll; release on page/carousel scrolling so it cannot float away.
  window.addEventListener('scroll', function (event) {
    if (active && !active.panel.contains(event.target instanceof Node ? event.target : null)) close(false);
  }, { passive: true, capture: true });
  window.addEventListener('resize', function () { close(false); }, { passive: true });
  window.addEventListener('blur', function () { close(false); });
  window.addEventListener('pagehide', function () { close(false); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) close(false); });
  ['mip:collection:loading', 'mip:collection:updated', 'shopify:section:unload', 'mip:surface:open'].forEach(function (name) {
    document.addEventListener(name, function () { close(false); });
  });
  desktop.addEventListener('change', function () { close(false); dismissed = null; });
})();
